import React, { useCallback, useEffect, useState } from 'react';
import { Container } from '@mui/material';
import { useSelector } from 'react-redux';
import { MetaTags } from '../../components/Metatags/Metatags';
import { companyDetailsSelector } from '../../selectors/selectors';
import { CompanyContainer } from '../../components/ScreenContainer/CompanyContainer/CompanyContainer';
import { CompanyEditContainer } from '../../components/CompanyComponents/CompanyEditContainer';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getCompanyDetails } from '../../redux/company/actions';
import { capitalizeWords } from '../../utils/AppUtils';

const LIMIT = 3;
export const Company = () => {
    const params = useParams();
    const { id } = params;
    const dispatch = useDispatch();
    const { details, loading } = useSelector(companyDetailsSelector);
    const [isEditMode, setIsEditMode] = useState(false);

    const getCompanyDetailsTrigger = useCallback(() => {
        if (id) {
            dispatch(
                getCompanyDetails({
                    slug: id,
                    withReviews: true,
                    withAuditions: true,
                    withJobs: true,
                    withCampaigns: true,
                    withLeadership: true,
                    withSimilarCompanies: true,
                    reviewsPage: 1,
                    auditionsPage: 1,
                    jobsPage: 1,
                    campaignsPage: 1,
                    reviewsLimit: LIMIT,
                    auditionsLimit: LIMIT,
                    jobsLimit: LIMIT,
                    campaignsLimit: LIMIT,
                }),
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    useEffect(() => {
        getCompanyDetailsTrigger();
    }, [getCompanyDetailsTrigger]);

    const handleCancelEdit = () => {
        setIsEditMode(false);
    };

    return (
        <MetaTags
            description={`${details?.company.about}`}
            title={`${details?.company.company_name ?? 'Company'} | ${capitalizeWords(details?.company.company_type)}`}>
            <Container
                disableGutters
                style={{
                    display: 'flex',
                    width: '100%',
                    minHeight: '100vh',
                }}
                maxWidth={false}
                sx={{ marginLeft: 0, width: '100%', maxWidth: '100%' }}>
                {isEditMode ? (
                    <CompanyEditContainer companyDetails={details} onCancel={handleCancelEdit} />
                ) : (
                    <CompanyContainer
                        companyDetails={details}
                        loading={loading}
                        onEditClick={() => setIsEditMode(true)}
                    />
                )}
            </Container>
        </MetaTags>
    );
};

// Wrap the component with route-based coming soon HOC
// export const Company = withRouteBasedComingSoon(CompanyComponent, {
//     routes: [
//         {
//             path: '/company/:id',
//             title: 'Company Profiles Coming Soon',
//             description:
//                 "Company profile pages are currently under development. We're building an amazing experience for you!",
//             estimatedDate: 'Q1 2026',
//         },
//     ],
//     // Set to true during development to see the actual content
//     showChildren: true,
// });
